import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count"]
  static values = { owner: String, repo: String }

  connect() {
    this.loadCount()
  }

  async loadCount() {
    try {
      const response = await fetch(
        `https://api.github.com/repos/${this.ownerValue}/${this.repoValue}`,
        { headers: { Accept: "application/vnd.github+json" } }
      )

      if (!response.ok) throw new Error(`GitHub API ${response.status}`)

      const data = await response.json()
      const stars = data.stargazers_count

      this.countTarget.textContent = stars.toLocaleString()
      this.countTarget.removeAttribute("aria-hidden")
      this.element.setAttribute(
        "aria-label",
        `Star ${this.ownerValue}/${this.repoValue} on GitHub (${stars.toLocaleString()} stars)`
      )
    } catch (error) {
      console.warn("Could not load GitHub star count:", error)
      this.countTarget.textContent = "—"
    }
  }
}
